import React, { useState } from 'react';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useAuth } from '../../hooks/useAuth';
import { uuid } from 'zod';

// CSS Styles with reduced padding
const styles = `
  .employee-form-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 16px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    background-color: #e2e5e8;
    min-height: 100vh;
  }

    .form-header {
    margin-bottom: 24px;
    padding-bottom: 16px;
    padding-horizontal: 20px;
    background-color: #ffffff;    
    border-radius: 8px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    border-bottom: 1px solid #e0e0e0;
  }

  .form-title-row {
    display: flex;
    justify-content: space-between;
    background: #66afce;
    align-items: center;
    margin-bottom: 8px;
  }

  .form-title {
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.2s;
    box-sizing: border-box;
  }

  .form-subtitle {
    padding: 6px 12px;
    background: #dc3545;
    color: #ffffff;
    font-weight: 500;
    margin: 0;

     border: none;
    border-radius: 3px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
    box-sizing: border-box;
  }

  .form-status {
    font-size: 14px;
    color: #666;
    margin: 0;
  }

  .form-content {
    background-color: #FAFAFA;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }

  fieldset {
  padding:0 20px 20px 20px;
  margin-bottom:10px;
  border:1px solid #1E96C8;
  }
  legend {
  color: #1E96C8;
  font-weight:bold
  }

  /* Tabs Navigation */
  .tabs-navigation {
    display: flex;
     background: linear-gradient(-180deg, #f8f8f8 0%, #a9a9a9 100%);
    border-bottom: 1px solid #e0e0e0;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .tab-item {
    padding: 12px 20px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    color: #000000;
    transition: background 0.1s, color 0.1s;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    white-space: nowrap;
  }

  .tab-item:hover {
    color: #007bff;
    background-color: #ffffff;
  }

  .tab-item.active {
    color: #007bff;
    border-bottom-color: #007bff;
    background-color: #f8f9fa;
  }

  /* Tab Content */
  .tab-content {
    padding: 20px;
  }

  .tab-pane {
    display: none;
  }

  .tab-pane.active {
    display: block;
  }

  /* Form Grid */
  .form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
  }

  .form-group {
    margin-bottom: 12px;
  }

  .form-label {
    display: block;
    font-size: 13px;
    font-weight: 500;
    color: #555;
    margin-bottom: 4px;
  }

  .required-label::after {
    content: " *";
    color: #dc3545;
  }
    
  .form-input:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
  }

  .form-input::placeholder {
    color: #050505;
    font-size: 13px;
  }

  input, textarea {
  background-color: #d9eef8;
  }
  input, textarea {
  padding:3px;
   height: 34px;
  border:1px solid #9adaee;
  border-radius:5px;
  width:200px;
  box-shadow:1px 1px 2px #3ec7f1 inset;
  }

  .form-select {
    font-size: 14px;
   height: 20px;
  }

  .form-select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
  }

  .form-textarea {
    width: 100%;
    padding: 6px 10px;
    font-size: 14px;
    color: #333;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 3px;
    resize: vertical;
    min-height: 80px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    box-sizing: border-box;
  }

  .form-textarea:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
  }

  .form-checkbox {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    accent-color: #007bff;
  }



  .checkbox-group {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .checkbox-label {
    font-size: 14px;
    color: #555;
    vertical-align: middle;
  }

  .error-message {
    display: block;
    margin-top: 3px;
    font-size: 11px;
    color: #dc3545;
  }

  /* Tag Input System */
  .tag-input-container {
    margin-bottom: 8px;
  }

  .tag-input-wrapper {
    display: flex;
    gap: 6px;
    margin-bottom: 6px;
  }

  .tag-input {
    flex: 1;
    padding: 6px 10px;
    font-size: 14px;
    border: 1px solid #ddd;
    border-radius: 3px;
    height: 34px;
    box-sizing: border-box;
  }

  .tag-button {
    padding: 6px 12px;
    background: #0d8fccff;
    color: #FFF;
    border: none;
    border-radius: 3px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
    height: 34px;
    box-sizing: border-box;
  }

  .tag-button:hover {
    background-color: #0056b3;
  }

  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 6px;
  }

  .tag-item {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 3px 8px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 500;
  }

  .skill-tag {
    background: #0d8fccff;
    color: #FFF;
    border: 1px solid #bbdefb;
  }

  .certification-tag {
    background-color: #e8f5e9;
    color: #2e7d32;
    border: 1px solid #c8e6c9;
  }

  .remove-tag {
    background: none;
    border: none;
    color: inherit;
    font-size: 14px;
    cursor: pointer;
    padding: 0;
    margin-left: 3px;
    line-height: 1;
  }

  .remove-tag:hover {
    opacity: 0.7;
  }

  .no-items {
    font-size: 12px;
    color: #999;
  }

  /* Section Header */
  .section-header {
    font-size: 16px;
    font-weight: 600;
    color: #09779c;
    background: #e1e5e5;
    margin: 20px 0 12px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
  }

  /* Form Actions */
  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e0e0e0;
    background-color: white;
    padding: 16px 20px;
  }

  .reset-button {
    padding: 8px 16px;
    background-color: white;
    color: #555;
    border: 1px solid #ddd;
    border-radius: 3px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
  }

  .reset-button:hover {
    background-color: #f8f9fa;
  }

  .save-button {
    padding: 8px 24px;
    background-image: linear-gradient(-180deg, #37AEE2 0%, #1E96C8 100%);
    color: #FFF;
    border: none;
    border-radius: 3px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
  }

  .save-button:hover {
    background-color: #218838;
  }

  .save-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .cancel-button {
    padding: 8px 16px;
    background-color: white;
    color: #555;
    border: 1px solid #ddd;
    border-radius: 3px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
  }

  .cancel-button:hover {
    background-color: #f8f9fa;
  }

  /* Alert Messages */
  .alert {
    padding: 10px 14px;
    border-radius: 3px;
    margin-bottom: 16px;
    font-size: 13px;
  }

  .alert-success {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  }

  .alert-error {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  }

  /* Field Group */
  .field-group {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 12px;
    margin-bottom: 16px;
  }

  /* Full Width Field */
  .full-width {
    grid-column: 1 / -1;
  }

  /* Readonly Field */
  .readonly-field {
    background-color: #f8f9fa;
    color: #666;
    cursor: not-allowed;
  }

  /* Date Input Styling */
  input[type="date"] {
    position: relative;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0.6;
    cursor: pointer;
  }

  /* Phone Input */
  .phone-input {
    position: relative;
  }

  .phone-prefix {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #666;
    font-size: 14px;
    pointer-events: none;
  }

  .phone-input input {
    padding-left: 40px;
  }
`;

// Dropdown options
const titleOptions = [
  { value: '', label: 'Choisir un titre' },
  { value: 'Mr', label: 'Mr' },
  { value: 'Mrs', label: 'Mrs' },
  { value: 'Ms', label: 'Ms' },
  { value: 'Dr', label: 'Dr' },
  { value: 'Prof', label: 'Prof' },
];

const genderOptions = [
  { value: '', label: 'Choisir un genre' },
  { value: 'Male', label: 'Masculin' },
  { value: 'Female', label: 'Féminin' },
  { value: 'Non-binary', label: 'Non-binaire' },
  { value: 'Prefer not to say', label: 'Préfère ne pas répondre' },
];

const pronounOptions = [
  { value: '', label: 'Choisir un pronom' },
  { value: 'He/Him', label: 'He/Him' },
  { value: 'She/Her', label: 'She/Her' },
  { value: 'They/Them', label: 'They/Them' },
  { value: 'Other', label: 'Other' },
];

const employeeTypeOptions = [
  { value: '', label: 'Choisir un type d\'employé' },
  { value: 'FULL_TIME', label: 'Temps Plein' },
  { value: 'PART_TIME', label: 'Temps Partiel' },
  { value: 'CONTRACTOR', label: 'Contractuel' },
  { value: 'INTERN', label: 'Stagiaire' },
  { value: 'TEMPORARY', label: 'Temporaire' },
  { value: 'FREELANCER', label: 'Freelance' },
  { value: 'CONSULTANT', label: 'Consultant' },
];

const employmentStatusOptions = [
  { value: '', label: 'Choisir un statut' },
  { value: 'ACTIVE', label: 'Actif' },
  { value: 'ON_LEAVE', label: 'En congé' },
  { value: 'SUSPENDED', label: 'Suspendu' },
  { value: 'TERMINATED', label: 'Résilié' },
  { value: 'RESIGNED', label: 'Démissionné' },
  { value: 'RETIRED', label: 'Retraité' },
  { value: 'PROBATION', label: 'Probation' },
];

const workScheduleOptions = [
  { value: '', label: 'Choisir un horaire de travail' },
  { value: 'STANDARD', label: 'Standard (9-5)' },
  { value: 'FLEXIBLE', label: 'Heures Flexibles' },
  { value: 'SHIFT', label: 'Travail de Nuit' },
  { value: 'REMOTE', label: 'Télétravail' },
  { value: 'HYBRID', label: 'Hybride' },
  { value: 'NIGHT_SHIFT', label: 'Travail de Nuit' },
  { value: 'WEEKEND', label: 'Weekend' },
];

const accessLevelOptions = [
  { value: 'BASIC', label: 'Basique' },
  { value: 'ELEVATED', label: 'Élevé' },
  { value: 'ADMIN', label: 'Administrateur' },
  { value: 'SUPER_ADMIN', label: 'Super Administrateur' },
];

const timezoneOptions = [
  { value: 'UTC', label: 'UTC' },
  { value: 'EST', label: 'Eastern Time (EST)' },
  { value: 'CST', label: 'Central Time (CST)' },
  { value: 'MST', label: 'Mountain Time (MST)' },
  { value: 'PST', label: 'Pacific Time (PST)' },
];

const languageOptions = [
  { value: 'en', label: 'Anglais' },
  { value: 'fr', label: 'Français' },
  { value: 'es', label: 'Espagnol' },
  { value: 'de', label: 'Allemand' },
  { value: 'it', label: 'Italien' },
];

// Tab definitions
const tabs = [
  { id: 'overview', label: 'Aperçu' },
  { id: 'joining', label: 'Intégration' },
  { id: 'address-contacts', label: 'Adresses & Contacts' },
  { id: 'personal', label: 'Informations Personnelles' },
  { id: 'profile', label: 'Profil' },
];

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    height: '34px', // Set the desired height
    backgroundColor: '#d9eef8',
    borderColor: state.isFocused ? '#007bff' : '#9adaee',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(0, 123, 255, 0.1)' : '1px 1px 2px #3ec7f1 inset',
    minHeight: '34px', // Ensure minHeight also matches
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '100%', // Make valueContainer take full height of the control
    padding: '0 8px', // Adjust padding as needed
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '100%', // Ensure indicators (arrows, clear icon) also match
  }),
  // You might also need to adjust the indicator components' padding if reducing height significantly
  dropdownIndicator: (provided, state) => ({
    ...provided,
    paddingTop: '0',
    paddingBottom: '0',
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    paddingTop: '0',
    paddingBottom: '0',
  }),
};

// CSS Style component
const FormStyles = () => <style>{styles}</style>;

// User Create Form Component with Tabs
const UserCreateForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { register, isAuthenticated, loading, error, clearError } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');


  // Form state
  const [formData, setFormData] = useState({
    // Overview Tab
    employeeId: '',
    email: '',
    username: '',
    isActive: true,

    // Joining Tab
    hireDate: '',
    startDate: '',
    employeeType: '',
    employmentStatus: '',
    department: '',
    jobTitle: '',
    managerId: '',

    // Address & Contacts Tab
    phoneNumber: '',
    workPhone: '',
    mobilePhone: '',
    emergencyContactName: '',
    emergencyContactPhone: '',
    emergencyContactRelationship: '',
    officeLocation: '',
    floor: '',
    deskNumber: '',

    // Salary Tab
    salary: '',
    currency: 'USD',
    payGrade: '',
    bonusEligible: false,

    // Personal Tab
    title: '',
    firstName: '',
    middleName: '',
    lastName: '',
    displayName: '',
    dateOfBirth: '',
    gender: '',
    pronoun: '',

    // Profile Tab
    timezone: 'UTC',
    language: 'fr',
    workSchedule: '',
    accessLevel: 'BASIC',
    isEmailVerified: false,
    twoFactorEnabled: false,
    bio: '',
    expertise: '',
    skills: [],
    certifications: [],

  });

  const [errors, setErrors] = useState({});
  const [skills, setSkills] = useState([]);
  const [newSkill, setNewSkill] = useState('');
  const [certifications, setCertifications] = useState([]);
  const [newCertification, setNewCertification] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSelectChange = (selectedOption, name) => {
    //console.log(formData);

    setFormData({
      ...formData,
      [name]: selectedOption.value, // Access the value property
    });

    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const addSkill = () => {
    if (newSkill.trim() && !skills.includes(newSkill.trim())) {
      const updatedSkills = [...skills, newSkill.trim()];
      setSkills(updatedSkills);
      setFormData(prev => ({ ...prev, skills: updatedSkills }));
      setNewSkill('');
    }
  };

  const removeSkill = (skillToRemove) => {
    const updatedSkills = skills.filter(skill => skill !== skillToRemove);
    setSkills(updatedSkills);
    setFormData(prev => ({ ...prev, skills: updatedSkills }));
  };

  const addCertification = () => {
    if (newCertification.trim() && !certifications.includes(newCertification.trim())) {
      const updatedCertifications = [...certifications, newCertification.trim()];
      setCertifications(updatedCertifications);
      setFormData(prev => ({ ...prev, certifications: updatedCertifications }));
      setNewCertification('');
    }
  };

  const removeCertification = (certToRemove) => {
    const updatedCertifications = certifications.filter(cert => cert !== certToRemove);
    setCertifications(updatedCertifications);
    setFormData(prev => ({ ...prev, certifications: updatedCertifications }));
  };

  const validateForm = () => {
    const newErrors = {};

    // Required fields validation
    if (!formData.email) newErrors.email = 'L\'adresse email est requise';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Adresse email invalide';

    if (!formData.firstName) newErrors.firstName = 'Le prénom est requis';
    if (!formData.lastName) newErrors.lastName = 'Le nom de famille est requis';
    if (!formData.employeeType) newErrors.employeeType = 'Le type d\'employé est requis';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitError('');
    setSubmitSuccess(false);

    try {
      const userData = {
        ...formData,
        dateOfBirth: formData.dateOfBirth ? new Date(formData.dateOfBirth).toISOString() : null,
        hireDate: formData.hireDate ? new Date(formData.hireDate).toISOString() : null,
        startDate: formData.startDate ? new Date(formData.startDate).toISOString() : null,
        terminationDate: formData.terminationDate ? new Date(formData.terminationDate).toISOString() : null,
      };

      // Call your API endpoint
      register(userData);
      setSubmitSuccess(true);

      // Auto-hide success message after 5 seconds
      //navigate('/admin/users');
    } catch (error) {
      console.error('Error creating user:', error);
      setSubmitError(error.message || 'Failed to create user. Please try again.');
    }
  };

  const resetForm = () => {
    setFormData({
      employeeId: '',
      email: '',
      username: '',
      isActive: true,
      hireDate: '',
      startDate: '',
      employeeType: '',
      employmentStatus: '',
      department: '',
      jobTitle: '',
      managerId: '',
      phoneNumber: '',
      workPhone: '',
      mobilePhone: '',
      emergencyContactName: '',
      emergencyContactPhone: '',
      emergencyContactRelationship: '',
      officeLocation: '',
      floor: '',
      deskNumber: '',
      salary: '',
      currency: 'USD',
      payGrade: '',
      bonusEligible: false,
      title: '',
      firstName: '',
      middleName: '',
      lastName: '',
      displayName: '',
      dateOfBirth: '',
      gender: '',
      pronoun: '',
      timezone: 'UTC',
      language: 'fr',
      workSchedule: '',
      accessLevel: 'BASIC',
      isEmailVerified: false,
      twoFactorEnabled: false,
      bio: '',
      expertise: '',
      skills: [],
      certifications: []
    });
    setSkills([]);
    setCertifications([]);
    setErrors({});
    setSubmitError('');
    setSubmitSuccess(false);
  };

  return (
    <>
      <FormStyles />
      <div className="employee-form-container">
        <div className="form-header">
          <div className="form-title-row">
            <h1 className="form-title">Nouvel Utilisateur</h1>
            <span className="form-subtitle">Non Sauvegardé</span>
          </div>
          <p className="form-status">Remplissez les détails de l'utilisateur ci-dessous. Les champs marqués d'une * sont obligatoires.</p>
        </div>

        {submitSuccess && (
          <div className="alert alert-success">
            Utilisateur créé avec succès!
          </div>
        )}

        {submitError && (
          <div className="alert alert-error">
            {submitError}
          </div>
        )}

        <div className="form-content">
          {/* Tabs Navigation */}
          <ul className="tabs-navigation">
            {tabs.map(tab => (
              <li
                key={tab.id}
                className={`tab-item ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </li>
            ))}
          </ul>

          <form onSubmit={handleSubmit}>
            {/* Tab Content */}
            <div className="tab-content">

              {/* Overview Tab */}
              <div className={`tab-pane ${activeTab === 'overview' ? 'active' : ''}`}>
                <div className="field-group">
                  <div className="form-group">
                    <label className="form-label required-label">ID Employé</label>
                    <input
                      type="text"
                      name="employeeId"
                      value={formData.employeeId}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="EMP001"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label required-label">Adresse Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="employee@company.com"
                    />
                    {errors.email && (
                      <span className="error-message">{errors.email}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Nom d'Utilisateur</label>
                    <input
                      type="text"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="username"
                    />
                  </div>

                  <div className="form-group">
                    <div className="checkbox-group">
                      <input
                        type="checkbox"
                        name="isActive"
                        checked={formData.isActive}
                        onChange={handleChange}
                        className="form-checkbox"
                      />
                      <label className="checkbox-label">Statut</label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Joining Tab */}
              <div className={`tab-pane ${activeTab === 'joining' ? 'active' : ''}`}>
                <div className="field-group">
                  <div className="form-group">
                    <label className="form-label">Date d'Embauche</label>
                    <input
                      type="date"
                      name="hireDate"
                      value={formData.hireDate}
                      onChange={handleChange}
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Date de Début</label>
                    <input
                      type="date"
                      name="startDate"
                      value={formData.startDate}
                      onChange={handleChange}
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label required-label">Type d'Employé</label>
                    <Select
                      name="employeeType"
                      value={employeeTypeOptions.find(option => option.value === formData.employeeType) || null}
                      inputId='employeeType'
                      styles={customStyles}
                      id='employeeType'
                      onChange={(selectedOption) => handleSelectChange(selectedOption, 'employeeType')}
                      options={employeeTypeOptions}
                      placeholder="Type employé ..."
                      isSearchable={true}
                    />
                    {errors.employeeType && (
                      <span className="error-message">{errors.employeeType}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Statut d'Employement</label>
                    <Select
                      name="employmentStatus"
                      inputId='employmentStatus'
                      value={employmentStatusOptions.find(option => option.value === formData.employmentStatus) || null}
                      styles={customStyles}
                      id='employmentStatus'
                      onChange={(selectedOption) => handleSelectChange(selectedOption, 'employmentStatus')}
                      options={employmentStatusOptions}
                      placeholder="Statut d'employement ..."
                      isSearchable={true}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Départment</label>
                    <input
                      type="text"
                      name="department"
                      value={formData.department}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="Engineering"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Titre du Poste</label>
                    <input
                      type="text"
                      name="jobTitle"
                      value={formData.jobTitle}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="Software Engineer"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Manager ID</label>
                    <input
                      type="text"
                      name="managerId"
                      value={formData.managerId}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="MAN001"
                    />
                  </div>
                </div>
              </div>

              {/* Address & Contacts Tab */}
              <div className={`tab-pane ${activeTab === 'address-contacts' ? 'active' : ''}`}>
                <fieldset>
                  <legend>Informations de Contact</legend>
                  <div className="field-group">
                    <div className="form-group">
                      <label className="form-label">Numéro de Téléphone</label>
                      <div className="phone-input">
                        <input
                          type="tel"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          className="form-input"
                          placeholder="234 567 8900"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Téléphone de Travail</label>
                      <div className="phone-input">
                        <input
                          type="tel"
                          name="workPhone"
                          value={formData.workPhone}
                          onChange={handleChange}
                          className="form-input"
                          placeholder="234 567 8901"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Mobile Phone</label>
                      <div className="phone-input">
                        <input
                          type="tel"
                          name="mobilePhone"
                          value={formData.mobilePhone}
                          onChange={handleChange}
                          className="form-input"
                          placeholder="234 567 8902"
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <legend>Contact d'Urgence</legend>
                  <div className="field-group">
                    <div className="form-group">
                      <label className="form-label">Nom du Contact</label>
                      <input
                        type="text"
                        name="emergencyContactName"
                        value={formData.emergencyContactName}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Jane Doe"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Téléphone de Contact</label>
                      <div className="phone-input">
                        <input
                          type="tel"
                          name="emergencyContactPhone"
                          value={formData.emergencyContactPhone}
                          onChange={handleChange}
                          className="form-input"
                          placeholder="234 567 8903"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Relation avec le Contact</label>
                      <input
                        type="text"
                        name="emergencyContactRelationship"
                        value={formData.emergencyContactRelationship}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Spouse"
                      />
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <legend>Emplacement de Travail</legend>
                  <div className="field-group">
                    <div className="form-group">
                      <label className="form-label">Emplacement du Bureau</label>
                      <input
                        type="text"
                        name="officeLocation"
                        value={formData.officeLocation}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="New York Office"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Étage</label>
                      <input
                        type="text"
                        name="floor"
                        value={formData.floor}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="5th Floor"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Numéro de Bureau</label>
                      <input
                        type="text"
                        name="deskNumber"
                        value={formData.deskNumber}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="501"
                      />
                    </div>
                  </div>
                </fieldset>
              </div>

              {/* Personal Tab */}
              <div className={`tab-pane ${activeTab === 'personal' ? 'active' : ''}`}>
                <div className="field-group">
                  <div className="form-group">
                    <label className="form-label">Titre</label>
                    <Select
                      name="title"
                      inputId='title'
                      value={titleOptions.find(option => option.value === formData.title) || null}
                      styles={customStyles}
                      id='title'
                      onChange={(selectedOption) => handleSelectChange(selectedOption, 'title')}
                      options={titleOptions}
                      placeholder="Titre ..."
                      isSearchable={true}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label required-label">Prénom</label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="John"
                    />
                    {errors.firstName && (
                      <span className="error-message">{errors.firstName}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Nom du Milieu</label>
                    <input
                      type="text"
                      name="middleName"
                      value={formData.middleName}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="Michael"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label required-label">Nom de Famille</label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="Doe"
                    />
                    {errors.lastName && (
                      <span className="error-message">{errors.lastName}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Nom d'Affichage</label>
                    <input
                      type="text"
                      name="displayName"
                      value={formData.displayName}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="John D."
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Date de Naissance</label>
                    <input
                      type="date"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleChange}
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Genre</label>
                    <Select
                      name="gender"
                      inputId='gender'
                      value={genderOptions.find(option => option.value === formData.gender) || null}
                      styles={customStyles}
                      id='gender'
                      onChange={(selectedOption) => handleSelectChange(selectedOption, 'gender')}
                      options={genderOptions}
                      placeholder="Genre ..."
                      isSearchable={true}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Pronom</label>
                    <Select
                      name="pronoun"
                      inputId='pronoun'
                      value={pronounOptions.find(option => option.value === formData.pronoun) || null}
                      styles={customStyles}
                      id='pronoun'
                      onChange={(selectedOption) => handleSelectChange(selectedOption, 'pronoun')}
                      options={pronounOptions}
                      placeholder="Pronom ..."
                      isSearchable={true}
                    />
                  </div>
                </div>
              </div>

              {/* Profile Tab */}
              <div className={`tab-pane ${activeTab === 'profile' ? 'active' : ''}`}>
                <div className="field-group">
                  <div className="form-group">
                    <label className="form-label">Fuseau Horaire</label>
                    <Select
                      name="timezone"
                      inputId='timezone'
                      value={timezoneOptions.find(option => option.value === formData.timezone) || null}
                      styles={customStyles}
                      id='timezone'
                      onChange={(selectedOption) => handleSelectChange(selectedOption, 'timezone')}
                      options={timezoneOptions}
                      placeholder="Fuseau Horaire ..."
                      isSearchable={true}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Langue</label>
                    <Select
                      name="language"
                      inputId='language'
                      value={languageOptions.find(option => option.value === formData.language) || null}
                      styles={customStyles}
                      id='language'
                      onChange={(selectedOption) => handleSelectChange(selectedOption, 'language')}
                      options={languageOptions}
                      placeholder="Langue ..."
                      isSearchable={true}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Planning de Travail</label>
                    <Select
                      name="workSchedule"
                      inputId='workSchedule'
                      value={workScheduleOptions.find(option => option.value === formData.workSchedule) || null}
                      styles={customStyles}
                      id='workSchedule'
                      onChange={(selectedOption) => handleSelectChange(selectedOption, 'workSchedule')}
                      options={workScheduleOptions}
                      placeholder="Planning de Travail ..."
                      isSearchable={true}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Niveau d'Accès</label>
                    <Select
                      name="accessLevel"
                      inputId='accessLevel'
                      value={accessLevelOptions.find(option => option.value === formData.accessLevel) || null}
                      styles={customStyles}
                      id='accessLevel'
                      onChange={(selectedOption) => handleSelectChange(selectedOption, 'accessLevel')}
                      options={accessLevelOptions}
                      placeholder="Niveau d'Accès ..."
                      isSearchable={true}
                    />
                  </div>

                  <div className="form-group">
                    <div className="checkbox-group">
                      <input
                        type="checkbox"
                        name="isEmailVerified"
                        checked={formData.isEmailVerified}
                        onChange={handleChange}
                        className="form-checkbox"
                      />
                      <label className="checkbox-label">Email Verifié</label>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="checkbox-group">
                      <input
                        type="checkbox"
                        name="twoFactorEnabled"
                        checked={formData.twoFactorEnabled}
                        onChange={handleChange}
                        className="form-checkbox"
                      />
                      <label className="checkbox-label">Authentification à Deux Facteurs</label>
                    </div>
                  </div>
                </div>

                <h3 className="section-header">Skills</h3>
                <div className="form-group">
                  <div className="tag-input-container">
                    <div className="tag-input-wrapper">
                      <input
                        type="text"
                        value={newSkill}
                        onChange={(e) => setNewSkill(e.target.value)}
                        className="tag-input"
                        placeholder="Add a skill (e.g., JavaScript)"
                        onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addSkill())}
                      />
                      <button
                        type="button"
                        onClick={addSkill}
                        className="tag-button"
                      >
                        Ajouter
                      </button>
                    </div>
                    <div className="tags-container">
                      {skills.map((skill, index) => (
                        <span
                          key={index}
                          className="tag-item skill-tag"
                        >
                          {skill}
                          <button
                            type="button"
                            onClick={() => removeSkill(skill)}
                            className="remove-tag"
                          >
                            ×
                          </button>
                        </span>
                      ))}
                      {skills.length === 0 && (
                        <span className="no-items">Aucune compétence ajoutée pour l'instant</span>
                      )}
                    </div>
                  </div>
                </div>

                <h3 className="section-header">Certifications</h3>
                <div className="form-group">
                  <div className="tag-input-container">
                    <div className="tag-input-wrapper">
                      <input
                        type="text"
                        value={newCertification}
                        onChange={(e) => setNewCertification(e.target.value)}
                        className="tag-input"
                        placeholder="Add a certification (e.g., AWS Certified)"
                        onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addCertification())}
                      />
                      <button
                        type="button"
                        onClick={addCertification}
                        className="tag-button"
                      >
                        Ajouter
                      </button>
                    </div>
                    <div className="tags-container">
                      {certifications.map((cert, index) => (
                        <span
                          key={index}
                          className="tag-item certification-tag"
                        >
                          {cert}
                          <button
                            type="button"
                            onClick={() => removeCertification(cert)}
                            className="remove-tag"
                          >
                            ×
                          </button>
                        </span>
                      ))}
                      {certifications.length === 0 && (
                        <span className="no-items">Aucune certification ajoutée pour l'instant</span>
                      )}
                    </div>
                  </div>
                </div>

                <h3 className="section-header">Biography & Expertise</h3>
                <div className="field-group">
                  <div className="form-group full-width">
                    <label className="form-label">Bio</label>
                    <textarea
                      name="bio"
                      value={formData.bio}
                      onChange={handleChange}
                      className="form-textarea"
                      placeholder="Professional biography..."
                      rows="3"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label className="form-label">Domaines d'Expertise</label>
                    <textarea
                      name="expertise"
                      value={formData.expertise}
                      onChange={handleChange}
                      className="form-textarea"
                      placeholder="Areas of expertise..."
                      rows="2"
                    />
                  </div>
                </div>
              </div>

            </div>

            {/* Form Actions */}
            <div className="form-actions">
              <button
                type="button"
                onClick={resetForm}
                className="reset-button"
              >
                Réinitialiser
              </button>
              <button
                type="button"
                className="cancel-button"
                onClick={() => window.history.back()}
              >
                Annuler
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="save-button"
              >
                {isSubmitting ? 'Enregistrement...' : 'Enregistrer l\'Employé'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default UserCreateForm;